<swal #warnAlert
  title="Are you sure?" i18n-title
  text="Uploading a portfolio will overwrite any current properties." i18n-text
  icon="warning" [swalOptions]="swalWarnOptions">
</swal>
<swal #badFileAlert
  title="Unsupported File Type" i18n-title
  text="Portfolio upload only supports .csv, .xlsx or .xlsm file types." i18n-text
  icon="error" [swalOptions]="swalBadFileOptions">
</swal>

<div class="formfields-padding">
  <div class="formfields" fxLayout="row wrap" *ngIf="showInvolvedinConsultation()">
    <div class="formfields__container" fxFlex="60">
      <div class="file-upload" fxLayout="row">
        <div class="boxed-content__container">
          <h4>
            <span i18n>Was there a specific property involved in this consultation?</span>
            <span class="required">*</span>
          </h4>
          <div class="radio-container" fxLayout="row wrap">
            <div fxFlex="20">
              <mat-radio-button
                class="involved-in-consultation-yes"
                id="involved-in-consultation-yes"
                name="involved-in-consultation"
                [checked]="transaction?.involved_in_consultation === true"
                (change)="radioSelected($event.value)"
                [value]="true" i18n
                [disabled]="disableInvolvedinConsultation()"
                color="primary"
              >yes</mat-radio-button>
            </div>
            <div fxFlex="20">
              <mat-radio-button
                class="involved-in-consultation-no"
                id="involved-in-consultation-no"
                name="involved-in-consultation"
                [checked]="transaction?.involved_in_consultation === false"
                (change)="radioSelected($event.value)"
                [value]="false" i18n
                [disabled]="disableInvolvedinConsultation()"
                color="primary"
              >No</mat-radio-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="file-upload__upload" fxFlex="20" *ngIf="hideOptions()">
      <button mat-button mat-raised-button type="button" class="btn btn--upload" (click)="triggerUpload()" color="primary">
        <mat-icon>file_upload</mat-icon>
        <span i18n>Portfolio Upload</span>
        <input id="file-upload" type="file" (change)="fileChange($event)" accept=".csv,.xlsx,.xlsm" />
      </button>
    </div>
    <div class="file-upload__download" fxFlex="20" *ngIf="hideOptions()">
      <a mat-button mat-raised-button class="btn btn--excel" href="{{ dsfxlsxTemplate }}" download>
        <mat-icon>file_download</mat-icon>
        <span i18n>Excel Template<span>(75kb)</span></span>
      </a>
    </div>
  </div>

  <div class="file-upload" fxLayout="row" *ngIf="!transactionType">
    <div class="file-upload__upload" fxFlex="50" fxLayoutAlign="start">
      <button mat-button mat-raised-button type="button" class="btn btn--upload" (click)="triggerUpload()" color="primary">
        <mat-icon>file_upload</mat-icon>
        <span i18n>Portfolio Upload</span>
        <input id="file-upload" type="file" (change)="fileChange($event)" accept=".csv,.xlsx,.xlsm" />
      </button>
    </div>
    <div class="file-upload__download" fxFlex="50" fxLayoutAlign="end">
      <a mat-button mat-raised-button class="btn btn--excel" href="{{ xlsxTemplate }}" download>
        <mat-icon>file_download</mat-icon>
        <span i18n>Excel Template<span>(75kb)</span></span>
      </a>
    </div>
  </div>
</div>
